const cleanupAnnotations = (annotations) =>
  annotations.filter(({ text }) => !text.startsWith('Named entity expected'));

export default cleanupAnnotations;
